import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetAccountingSettings {
    accountingSettings {
      get {
        __typename
        ... on AccountingSettingsGetSuccess {
          settings {
            paymentByAchOrVirtualCcLeadDays
            paymentByCheckLeadDays
            paymentByWireLeadDays
          }
        }
        ... on AccountingSettingsGetFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
